
import { formatCurrency } from '@/utils/currency';
import FTextField from '@/components/atoms/forms/h-text-field';

export default {
  name: 'FCurrencyField',

  components: {
    FTextField,
  },

  props: {
    inputValue: {
      type: [String, Number, null],
      default: '',
    },
    suffix: {
      type: String,
      default: '€',
    },
    errorMessages: {
      type: [String, Array],
      default: '',
    },
    errorMessageFullWith: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [Boolean, String],
      default: false,
    },
    inputMode: {
      type: String,
      default: 'numeric',
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    backgroundColor: {
      type: String,
    },
    color: {
      type: String,
    },
    inlineEditor: {
      type: Boolean,
    },
  },

  data() {
    return {
      isFocused: false,
      value: '',
    };
  },

  watch: {
    inputValue(newValue) {
      this.value = this.format(newValue);
    },
  },

  mounted() {
    this.value = this.format(this.inputValue);
  },

  methods: {
    format(value) {
      if (this.isFocused) {
        return value;
      }

      /**
       * TODO: Fix `isNotEmpty` validation's handling of `null`
       * To help with the validation rules of `isRequired`
       * we need to pass a empty string. Otherwise `null`
       * will trigger the validation to be invalid on mount
       */
      return formatCurrency(value) || '';
    },

    handleFocus(e) {
      this.isFocused = true;

      if (this.value) {
        this.value = this.value.replace(/\D/g, '');
      }

      this.$emit('focus', e);
    },

    handleBlur(e) {
      this.isFocused = false;
      this.value = this.format(this.value);
      this.$emit('blur', e);
    },

    handleChange(e) {
      this.$emit('change', e);
    },

    handleInput(value = '') {
      const payload =
        typeof value === 'string' ? value.replace(/\D/g, '') : value;
      this.$emit('input', payload);
    },

    handleKeydown(e) {
      const specialKeys = [
        8, // Backspase
        9, // Tab
        37, // Left arrow
        38, // Up arrow
        39, // Right arrow
        40, // Down arrow
      ];

      const keyCode = e.which ? e.which : e.keyCode;
      const isNumberOrSpecial =
        (keyCode >= 48 && keyCode <= 57) || specialKeys.includes(keyCode);

      if (!isNumberOrSpecial) {
        e.preventDefault();
      }

      this.$emit('keydown', e);
    },
  },
};
